import script from "./transfer.vue?vue&type=script&setup=true&lang=ts"
export * from "./transfer.vue?vue&type=script&setup=true&lang=ts"

import "./transfer.vue?vue&type=style&index=0&id=5a1d33db&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a1d33db"]])

export default __exports__